export const LOAD_PAGELIST   = 'LOAD_PAGELIST'
export const PAGELIST_FAIL   = 'PAGELIST_FAIL'

export const LOAD_PAGE_DETAIL   = 'LOAD_PAGE_DETAIL'
export const PAGE_DETAIL_FAIL   = 'PAGE_DETAIL_FAIL'

export const LOAD_PAGE_CARDS   = 'LOAD_PAGE_CARDS'
export const PAGE_CARDS_FAIL   = 'PAGE_CARDS_FAIL'